import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ClaimActions from '../actions/claim.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { RewardsService } from '../../services/reward.service';

@Injectable()
export class ClaimEffects {
  constructor(private actions$: Actions, private api: RewardsService) { }
  claim$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClaimActions.ClaimActions.claimReward),
      switchMap(({ profileId, rewardId }) =>
        this.api.RewardsClaim(profileId, rewardId).pipe(
          map((response) => ClaimActions.ClaimActions.claimRewardSuccess({ data: "ok" })),
          catchError((err) => of(ClaimActions.ClaimActions.claimRewardFailure({ error: err?.message ?? 'Claim failed' }))),
        )
      )
    )
  );
}
